import { useQuery } from "@tanstack/react-query";
import { getRMShiftReport } from "../repositories/RMShiftReportRepository";

export const useRMShiftReport = (start: string, end: string) => {
	return useQuery({
		queryKey: ["rmShiftReport", start, end],
		queryFn: ({ signal }) => getRMShiftReport({ start, end, signal }),
		enabled: !!start && !!end,
	});
};
